<template>
<el-popover
    :title="$t('message.download.taskManager')"
    width="332"
    v-model="showDownloadPopover"
    popper-class="download-popover"
    placement="bottom-end"
    :visible-arrow="false"
    trigger="click"
    @show="fetchDownloadList">
  <div slot="reference" class="download-wrap">
    <div class="icon-download">
      <el-badge :is-dot="app.showDownloadTask" type="danger">
        <span circle class="task-center-btn">
          <img src="@/assets/images/task.png" />
        </span>
      </el-badge>
    </div>
  </div>
  <div class="download-content">
    <template v-if="downloadList.length > 0">
      <div v-for="(item, index) in downloadList" :key="index" class="download-content-item" @click="handleDownloadItem(item)">
        <p class="item-title">{{item.fileName}}</p>
        <p class="item-desc">
          <span class="item-desc-status">{{item.fileStatusText}}</span>
          <span class="item-desc-time">{{item.dateTime}}</span>
        </p>
      </div>
    </template>
    <template v-if="downloadList.length === 0">
      <empty-component :empty-subtitle="$t('message.tableCommon.searcnEmpty')"></empty-component>
    </template>
  </div>
  <div>
    <el-button size="small" type="default" class="btn-download-center" @click="handleDownloadCenter">{{$t("message.download.gotoDownloadCenter")}}</el-button>
  </div>
  <div class="margin-top-8">
    <el-button size="small" type="default" class="btn-download-center" @click="handleUploadDetails">{{$t("message.download.gotoUploadDetails")}}</el-button>
  </div>
</el-popover>
</template>
<script>
import { mapGetters } from 'vuex';

import { getDictionary } from '@/api/common/index';
import EmptyComponent from '@/components/table/empty-component.vue';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getTodayParams } from '@/utils/tools/time';
import DownloadService from '@/views/content/api/download';

export default {
  components: {
    EmptyComponent,
  },
  data() {
    return {
      showDownloadPopover: false,
      fileStatusList: [],
      downloadList: [],
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  created() {
    this.refreshDownload();
    getDictionary(['FILE_STATUS']).then((res) => {
      this.fileStatusList = initSelectedData(res.FILE_STATUS);
    }).catch(() => ({}));
  },
  destroyed() {
    if (this.noticeTimer) {
      clearTimeout(this.noticeTimer);
    }
  },
  methods: {
    async refreshDownload() {
      if (this.noticeTimer) {
        clearTimeout(this.noticeTimer);
      }

      // 获取接口信息
      await this.$store.dispatch('app/refreshDownloadTask');

      this.noticeTimer = setTimeout(() => {
        this.refreshDownload();
      }, 5 * 60 * 1000); // 每 5 分钟刷新
    },
    handleDownloadCenter() {
      this.showDownloadPopover = false;
      this.$router.push({ path: '/content/download' });
    },
    handleUploadDetails() {
      this.showDownloadPopover = false;
      this.$router.push({ path: '/content/upload' });
    },
    async handleDownloadItem(item) {
      if (item.fileStatus === 'GS') {
        window.location.href = item.fileUrl;
        await DownloadService.updateDownloadFlag({ fileId: item.id });
        this.$store.dispatch('app/refreshDownloadTask');
        return;
      }
      this.showDownloadPopover = false;
      this.$router.push({ path: '/content/download' });
    },
    async fetchDownloadList() {
      // 获取今日最新5条下载记录
      const res = await DownloadService.queryDownloadList({ ...getTodayParams('beginDateTime', 'endDateTime'), size: 5 });
      if (res.content && res.content.length) {
        this.downloadList = res.content.map((item) => ({
          id: item.id,
          fileName: item.fileName,
          fileUrl: item.fileUrl,
          dateTime: item.dateTime,
          fileStatus: item.fileStatus,
          fileStatusText: getEnantiomericValue(this.fileStatusList, item.fileStatus),
        }));
      }
    },
  },
};
</script>
<style lang="scss" scope>
@import '@/styles/element-variables.scss';
.download-wrap {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 35px;

  &:hover, &:active {
    background-color: #F4F6F8;
  }
  .task-center-btn {
    min-width: 0;
    width: 36px;
    height: 36px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 18px;
      height: 18px;
    }
  }
}
.icon-download {
  cursor: pointer;

  .icon-Download {
    color: $color-primary;
  }
}

.download-content {
  min-height: 60px;
  margin-bottom: 9px;
  min-height: 257px;
  .download-content-item {
    padding: 0 12px;
    height: 60px;
    cursor: pointer;

    .item-title {
      font-size: 14px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      color: #264373;
      line-height: 32px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .item-desc {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item-desc-status {
        font-size: 14px;
        font-family: AvenirNext-DemiBold, AvenirNext;
        font-weight: 600;
        color: #20BAD6;
        line-height: 19px;
      }

      .item-desc-time {
        font-size: 12px;
        font-family: Avenir-Book, Avenir;
        font-weight: normal;
        color: #264373;
      }
    }

    &:hover {
      background-color: #F4F6F8;
    }
  }
}

.btn-download-center {
  width: 100%;
  span {
    display: block !important;
    text-align: center;
    width: 100%;
  }
}
@media screen and (max-width: 992px) {
  .download-wrap {
    width: inherit;
    margin-right: 18px;
    .iconfont {
      font-size: 14px;
    }
  }
}
</style>
<style lang="scss">
.download-popover {
  margin-top: 5px !important;
  padding: 4px 12px 10px 12px !important;

  .el-popover__title {
    font-size: 14px;
    font-family: Avenir-Book, Avenir;
    font-weight: normal;
    color: rgba(0,32,63,0.6);
    line-height: 30px;
    margin: 0;
    padding-left: 12px;
  }
}
</style>
